<template><div><h1>VUX V2.7.5 发布日志</h1>
<h2><a href="/zh-CN/components/clocker.html">Clocker</a></h2>
<ul><li>[fix] 修复 beforeDestroy 调用时 this.clocker 不存在 #2258</li>
</ul>
<h2><a href="/zh-CN/components/panel.html">Panel</a></h2>
<ul><li>[fix] 移除重复顶部边框样式</li>
<li>[feature] 添加 slot:header slot:body #2270</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[fix] 修复plain样式并禁用时class不对的问题</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.5 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.5-263.vue?758a8801